import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ClientesConAcceso {

    constructor(private afDB: AngularFireDatabase, private afs: AngularFirestore,
        private http: HttpClient) { }

    public ObtenerViajesPorCLienteEntreFechas(idCliente, fechaInicial, fechaFinal) {
        return this.afs.collection('servicios', ref => ref
            .where('cliente', '==', idCliente)
            .where('estatus', '==', 'Asignado')
            .where('inicioDeServicio', '>=', fechaInicial)
            .where('inicioDeServicio', '<=', fechaFinal));
    }
    public obtenerViajePorServicio(idServicio) {
        return this.afs.collection('viajes', ref => ref.where('idServicio', '==', idServicio));
    }
    public obtenerIdClienteUsuario(currentUser) {
        return this.afDB.object('/contactosConAcceso/' + currentUser + '/cliente');
    }
    public obtenerViaje(idViaje){
        return this.afs.collection('viajes').doc(idViaje);
    }
    public obtenerServicio(idServicio){
        return this.afs.collection('servicios').doc(idServicio);
    }
    public generarNuevoPasajero(idCliente, pasajero) {
        let id = this.afs.createId();
        this.afs.collection('pasajerosPorCliente').doc(idCliente).collection("pasajeros").doc(id).set(pasajero);
        return id;
    }
    public editarNuevoPasajero(idCliente, pasajero) {
        let idObjeto = pasajero.$key;
        delete pasajero.$key;
        this.afs.collection('pasajerosPorCliente').doc(idCliente).collection("pasajeros").doc(idObjeto).update(pasajero);
    }
    public obtenerPasajerosPorCliente(idCliente) {
        return this.afs.collection('pasajerosPorCliente').doc(idCliente).collection("pasajeros");
    }
    public obtenerDetallePasajero(idCliente, idPasajero) {
        return this.afs.collection('pasajerosPorCliente').doc(idCliente).collection("pasajeros").doc(idPasajero);
    }
    public obteneRutasPorCliente(idCliente) {
        return this.afs.collection('ruasPorCliente').doc(idCliente);
    }
    actualizarRutas(cliente, rutas){
        return this.afs.collection('ruasPorCliente').doc(cliente).set(rutas)
    }

    public desHabilitarCliente(idCliente: string, deshabilitado: boolean) {
        let body = {
            uid: idCliente,
            dehabilitado: deshabilitado
        };
        return this.http.post('https://us-central1-trosten-efcb3.cloudfunctions.net/app/desHabilitarUsuario', body);
    }

    public obtenerNombreCliente(idCliente, idContactoAcceso){
        return this.afDB.object('/contactosPorClienteConAcceso/' + idCliente + '/'+ idContactoAcceso + '/nombre')
    }
    public obtenerpasajerosPorViaje(idViaje){
        return this.afs.collection('pasajerosPorViaje').doc(idViaje)
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/clientes-con-acceso.ts